import styles from './BadgeList.module.css';
import { PropsWithChildren } from 'react';
import classNames from 'classnames';

interface Props extends PropsWithChildren {
  inline?: boolean;
}

export function BadgeList({ inline, children }: Props) {
  return <div className={classNames(styles.badgeList, inline && styles.inline)}>{children}</div>;
}
